var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_46_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_46_3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_46_3",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_46_3",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA5JJREFUeJztmj1oFUEUhWcT9SVqFJN02gimEjSQIk0aUdBoYxNbMWIbBQULtTP+NuJ/a6wUjJb+giCSgAhKUihilIBGG6NgYgwkn8W+B2syM2/e7t3ZFfeU783cc86d2bvDnVWqQIECBQoU+G8RZC3ABqBOKbVLKdWhlPqolLodBMF0pqJ8AagD7vE3RoHmrLV5AbAXPc5nrS11AEF5tXV4JslVJxlMEDuUUhsN/33yKSQTAE8Mqw+wPWt9qQLYBMwbzI8AuX5zJQZw07L6+7LWlyqAtcBvg/mvQIM0Z96KYJ9Sapnhv4tBEMz4FKMF0AicBd4Cr4EjQL1A3CZg0rD6U0CLhH4Jkc81Ak8JxD5oefavaMYHwAHgKTAEHAWWJNVhE2gyX1mh2ORAPTBmiD0HtGnmHNeMfQA0JnOqF2gzX0HsMzrQY4k7qBlfD/w0jH8omgRH8yMJOYYtsbs041ur6JHZCY7mp4HOBBxdltjDlnnvUk1CDea3xiYJee5a4vdY5m0BZlNJArCCsLpWM78tofk2wiKnwweqFFZgJzBTRWdtNcGX+TLXVQtHn2MMuSR4Nt+MuZJ/A1bWECt5EnyaL/OdsPCcjhEvfhIyMF8CJgw8s8C6mHFrTwKwHA/VfoHQXgvXQMLYu3F7OzRUJlzwbN7W7wNoF+BwTUJJAZ99mS+L67bwPRLkcUlCv0sCRJ77iLDHFj7Rfh/Va8K4yyMwhdAuANotPKMI9/uATuCHhfOLaxEUSQIwYOHolTAd4eoEvlfxdb0y2OXcnygJ2Pt9E0DJs/lXwOropFTPAoRtNBOOCZrvIDxJVjPfqpucShKo3u9bLMa3+UgQ8SQAhyyxLufGfCSYWBII21fvDTHmgA25Mh8JKpIEYI9l/qJ+Xy7MR4Kvwu3tYGyJUWO/r0Z9rtU+fo1xTIK2KUrMfp+jrs2pm4+QuSRhUVscGLSMN/b7HDW99GI+QmhLwqKLEez9vjESXKcBa7yajxCbCuNJzdjE/T6LjqXAL6/mI+SNwBngDeHl6OGFqwm0EO4KHSaBJgEdlwzmc3GJqru3q+CMEEcJ6AfGCb8duEb0bJ8VSKnf988A2G9Z/RtZ60sVeOj35Rp46vflFsAtSwK6s9aXOjAflMT7fVKQ/kpsyPD7uSAIEObKHwgvPEcWrP4dwu/+cwnxbUl479ajlFqvlHqhlLofBMG8NE+BAgUKFChQIDH+AEEFdk2slNLwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.b0912357feb879d103893c771ba4bf1b.svg";
export { ForwardRef as ReactComponent };